var utils = require('util');
var PartView = require('./PartView');
var PartCache = require('../Models/PartCache');

var DepthPartView = module.exports = function(model, parentHeight, parentLength, parentDepth) {
    this.initDepthView(model, parentHeight, parentLength, parentDepth);
    this.cache = new PartCache();
};

utils.inherits(DepthPartView, PartView);

DepthPartView.prototype.initDepthView = function(model, parentHeight, parentLength, parentDepth) {
    this.initPartView(model, parentHeight, parentLength, parentDepth);
};

DepthPartView.prototype.scaleHeightParameter = function(size) {
    var scale = (this.parentHeight) / size;
    if(this.model.category === 'PANEL' || this.model.category === 'EDGE_PROTECTION') {
        scale = (this.parentHeight - this.scalePanelOffset)/size;
    }

    return  scale;
};

DepthPartView.prototype.scaleLengthParameter = function(size) {
    var scale = (this.parentLength) / size;

    if(this.model.category === 'PANEL' || this.model.category === 'EDGE_PROTECTION') {
        scale = (this.parentLength - this.scalePanelOffset) /size;
    }

    return  scale;
};

DepthPartView.prototype.scaleDepthParameter = function(size) {
    var scale = (this.parentDepth) / size;

    if(this.model.category === 'PANEL' || this.model.category === 'EDGE_PROTECTION') {
        scale = (this.parentDepth - this.scalePanelOffset)/size;
    }

    return  scale;
};


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Views/DepthPartView.js